import TiledProfileContent from 'components/Header/BeautyPreferences/TiledProfileContent/TiledProfileContent';
import { withTiledProfileContentProps } from 'viewModel/header/beautyPreferences/tiledProfileContent/withTiledProfileContentProps';

export default withTiledProfileContentProps(TiledProfileContent);
